module.exports = __webpack_public_path__ + "static/media/page3_mum_kids.f0f94876.png";